import { render, staticRenderFns } from "./OverlayLocationEdit.vue?vue&type=template&id=4d71066c&"
import script from "./OverlayLocationEdit.vue?vue&type=script&lang=js&"
export * from "./OverlayLocationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d71066c')) {
      api.createRecord('4d71066c', component.options)
    } else {
      api.reload('4d71066c', component.options)
    }
    module.hot.accept("./OverlayLocationEdit.vue?vue&type=template&id=4d71066c&", function () {
      api.rerender('4d71066c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/pages/OverlayLocationEdit.vue"
export default component.exports